import React from "react";
import { Segmented } from "antd";
import { PieChartOutlined, TableOutlined } from "@ant-design/icons";
import {PieChartRounded, TableRowsRounded} from "@mui/icons-material";

const ChartTypeMenu = ({ chartType, setChartType }) => {
  return (
    <Segmented
      options={[
        {
          label: <PieChartRounded />, // Icon for "Allocations Over Time"
          value: "indices",
        },
        {
          label: <TableRowsRounded />, // Icon for "Detailed Breakdown"
          value: "table",
        },
      ]}
      value={chartType}
      onChange={setChartType}
      style={{ width: 'fit-content' }}
    />
  );
};

export default ChartTypeMenu;
